module.exports = "https://portperrypedals.ca/_res/img/cyclelife.5d2a1cd.png";